import React, { ReactNode } from "react";
import {
  Container,
  Grid,
  GridItem,
  useBreakpointValue
} from "@chakra-ui/react";
import { Header, Sidebar } from "components";

interface Props {
  children?: ReactNode;
}

const AuthenticatedLayout: React.FC<Props> = ({ children }: Props) => {
  const isDesktop = useBreakpointValue({ base: false, xl: true });

  return (
    <Grid
      gridTemplateColumns={isDesktop ? "auto 1fr" : "1fr"}
      gridTemplateRows={isDesktop ? "auto 1fr" : "auto auto auto"}
      templateAreas={
        isDesktop
          ? "'sidebar header' 'sidebar content'"
          : "'header' 'sidebar' 'content'"
      }
    >
      <GridItem
        gridArea="header"
        zIndex={isDesktop ? 1100 : 1200}
        display={isDesktop ? "block" : "none"}
      >
        <Header />
      </GridItem>
      <GridItem gridArea="sidebar" zIndex={isDesktop ? 1200 : 1100}>
        <Sidebar isDesktop={isDesktop} />
      </GridItem>
      <GridItem gridArea="content" p={{ base: 4, md: 16 }}>
        <Container maxW="6xl" height="100%">
          {children}
        </Container>
      </GridItem>
    </Grid>
  );
};

export default AuthenticatedLayout;
